import React from "react";
import { Formik, Form } from "formik";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeactivateStaff = ({
    selectedData,
    setIsDeactivateStaff,
    deactivateStaffLoading,
    deactivateStaffMutate,
}) => {
    const handleDeactivateSubmit = () => {
        deactivateStaffMutate({ staffId: selectedData?.id });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeactivateStaff}
            title={
                selectedData?.status === 1
                    ? "Deactivate Staff Confirmation"
                    : "Activate Staff Confirmation"
            }
        >
            <WarningText>
                Are you sure you want to{" "}
                {selectedData?.status === 1 ? "deactivate" : "activate"}{" "}
                {selectedData?.name}
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeactivateStaff(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeactivateSubmit}
                    disabled={deactivateStaffLoading}
                    className={`border ${selectedData.status === 1
                            ? "border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                            : "border-green-500 bg-white text-green-500 hover:bg-green-500 hover:text-white"
                        }`}
                >
                    {deactivateStaffLoading ? "Processing..." : "Confirm"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeactivateStaff;
